module.exports = __webpack_public_path__ + "static/media/people.961065e2.svg";